import { User, MessagePartner, Player } from "../types";

export function formatName(firstName?: string, lastName?: string): string {
	let name = "";

	if (firstName) {
		name = firstName;
	}

	if (firstName && lastName) {
		name = name + " ";
	}

	if (lastName) {
		name = name + lastName;
	}

	return name;
}

export function formatUserName(user: User | Player | MessagePartner): string {
	return formatName(user.firstName, user.lastName);
}
